module.exports = __webpack_public_path__ + "static/media/STWire2.0ccd6ad6.png";